/**
 * Centralized API Configuration
 * All external API URLs should be defined here and read from environment variables
 */

// PM4Subs API - main backend for project management
export const PM4SUBS_API_URL =
  process.env.REACT_APP_PM4SUBS_API_URL ||
  process.env.REACT_APP_API_BASE_URL ||
  'https://beta.pm4subs.com';

// Photo upload worker URL - Cloudflare Worker for R2 uploads
export const PHOTO_UPLOAD_URL =
  process.env.REACT_APP_PHOTO_UPLOAD_URL ||
  'https://time4subs-uploads.ryan-b00.workers.dev';

// R2 Public bucket URL - for accessing publicly stored photos
export const R2_PUBLIC_URL =
  process.env.REACT_APP_R2_PUBLIC_URL ||
  'https://pub-91424f27b06a407bb95bcf26cd4dbde3.r2.dev';

// Voice transcription API URL
export const VOICE_API_URL =
  process.env.REACT_APP_VOICE_API_URL ||
  PM4SUBS_API_URL;

/**
 * Get API URL for a specific service
 * @param {'pm4subs' | 'photo_upload' | 'r2_public' | 'voice'} service
 * @returns {string} The API URL
 */
export function getApiUrl(service) {
  switch (service) {
    case 'pm4subs':
      return PM4SUBS_API_URL;
    case 'photo_upload':
      return PHOTO_UPLOAD_URL;
    case 'r2_public':
      return R2_PUBLIC_URL;
    case 'voice':
      return VOICE_API_URL;
    default:
      console.warn(`Unknown API service: ${service}`);
      return PM4SUBS_API_URL;
  }
}

/**
 * Build a full API endpoint URL
 * @param {'pm4subs' | 'photo_upload' | 'r2_public' | 'voice'} service
 * @param {string} path - API path (e.g., '/api/photos/upload')
 * @returns {string} Full URL
 */
export function buildApiUrl(service, path) {
  const baseUrl = getApiUrl(service);
  // Ensure path starts with /
  const normalizedPath = path.startsWith('/') ? path : `/${path}`;
  // Remove trailing slash from base URL
  const normalizedBase = baseUrl.replace(/\/$/, '');
  return `${normalizedBase}${normalizedPath}`;
}
